import { useCallback, useEffect, useState } from "react";

const STORAGE_KEY = "vu_sidebar_collapsed";

/**
 * Persistent sidebar collapsed state.
 *
 * - **Desktop (>= 1280px)**: defaults to expanded, user choice remembered.
 * - **Tablet (768–1279px)**: defaults to collapsed to give more content width;
 *   user can override and their choice sticks.
 * - **Mobile (< 768px)**: irrelevant (mobile uses the drawer, not a sidebar).
 */
export function useSidebarState() {
    const [collapsed, setCollapsed] = useState(() => {
        try {
            const stored = localStorage.getItem(STORAGE_KEY);
            if (stored !== null) return stored === "1";
            // First visit: tablets default to collapsed.
            if (typeof window !== "undefined") {
                return window.innerWidth < 1280;
            }
        } catch { /* ignore */ }
        return false;
    });

    // Persist changes.
    useEffect(() => {
        try { localStorage.setItem(STORAGE_KEY, collapsed ? "1" : "0"); }
        catch { /* localStorage may be unavailable in private mode */ }
    }, [collapsed]);

    const toggle = useCallback(() => setCollapsed((c) => !c), []);
    return { collapsed, setCollapsed, toggle };
}
